import api, { Notifiable } from '../api';

const controller = 'crfTipoClassificacaoProjeto';

export interface CrfTipoClassificacaoProjeto {
    id: string;
    codigo: number;
    descricao: string;
    ehFechamentoMina: boolean;
}


export const getAllCrfTipoClassificacaoProjeto = () => api.get<CrfTipoClassificacaoProjeto[]>(`${controller}`);
export const updateCrfTipoClassificacaoProjeto = (tipoClassificacaoProjeto: CrfTipoClassificacaoProjeto) => {
    return api
      .put<boolean>(`${controller}/updateCrfTipoClassificacaoProjeto/${tipoClassificacaoProjeto.id}`, tipoClassificacaoProjeto)
      .then(result => true)
      .catch(err => false);
  };